import { render, staticRenderFns } from "./FilterSwitch.vue?vue&type=template&id=99fa07a8&"
import script from "./FilterSwitch.vue?vue&type=script&lang=js&"
export * from "./FilterSwitch.vue?vue&type=script&lang=js&"
import style0 from "./FilterSwitch.vue?vue&type=style&index=0&id=99fa07a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports